'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSagas = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withSagas = exports.withSagas = function withSagas(_ref) {
  var _ref$load = _ref.load,
      load = _ref$load === undefined ? [] : _ref$load,
      _ref$watch = _ref.watch,
      watch = _ref$watch === undefined ? [] : _ref$watch;
  return function (WrappedComponent) {
    var DecoratedComponent = function (_Component) {
      (0, _inherits3.default)(DecoratedComponent, _Component);

      function DecoratedComponent() {
        var _ref2;

        (0, _classCallCheck3.default)(this, DecoratedComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DecoratedComponent.__proto__ || (0, _getPrototypeOf2.default)(DecoratedComponent)).call.apply(_ref2, [this].concat(args)));

        _this.loadSagas = [].concat(load).filter(Boolean);
        _this.watchSagas = [].concat(watch).filter(Boolean);
        _this.runSagas();
        return _this;
      }

      (0, _createClass3.default)(DecoratedComponent, [{
        key: 'runSagas',
        value: function runSagas() {
          var props = this.props,
              context = this.context;
          var store = context.store,
              client = context.client;


          this.watchSagas.forEach(function (saga) {
            return store.runSaga(saga, client, props);
          });
          this.loadSagas.forEach(function (saga) {
            return store.runSagaOnce(saga, client, props);
          });
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, this.props);
        }
      }]);
      return DecoratedComponent;
    }(_react.Component);

    DecoratedComponent.displayName = 'withSagas(' + (WrappedComponent.displayName || WrappedComponent.name) + ')';
    DecoratedComponent.contextTypes = {
      client: _propTypes2.default.object,
      store: _propTypes2.default.object
    };
    DecoratedComponent.withSagas = { load: load, watch: watch };

    return (0, _hoistNonReactStatics2.default)(DecoratedComponent, WrappedComponent);
  };
};